import { IconProps } from './types'

export default function IconReloadRed({
    width = '16',
    height = '16',
    className,
}: IconProps) {

    return (
        <svg
            width={width}
            height={height}
            viewBox='0 0 16 16'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
            className={className}
        >
            <g filter='url(#filter0_d_8809_5635)'>
                <path d='M8.23926 6.95898L7.13379 9.0459L7.09668 9.11621L7.01758 9.11426L5.70605 9.08691C8.39318 10.9892 11.6499 11.2239 14.1123 10.7148L14.2148 10.9424C12.3763 12.3235 10.2859 12.7723 8.39941 12.7021C6.6704 12.6378 5.10549 12.1367 4.05273 11.5127L4.30371 12.5156L4.32227 12.5918L4.2627 12.6436L2.47266 14.1846L2.28906 14.3428L2.2627 14.1016L1.53613 7.63965L1.52148 7.5127L1.64844 7.49805L8.11133 6.77246L8.35254 6.74512L8.23926 6.95898ZM13.8623 1.96582L14.4053 8.44629L14.416 8.57422L14.2891 8.58496L7.80859 9.12793L7.56738 9.14746L7.68652 8.9375L8.85059 6.88184L8.88867 6.81348L8.96777 6.81738L10.2793 6.88086C7.64697 4.90307 4.39678 4.57735 1.9209 5.0166L1.8252 4.78613C3.70215 3.45752 5.80462 3.06888 7.68848 3.19238C9.4146 3.30555 10.9643 3.84956 11.999 4.50293L11.7773 3.49414L11.7607 3.41699L11.8213 3.36719L13.6543 1.87695L13.8428 1.72461L13.8623 1.96582Z' fill='url(#paint0_linear_8809_5635)' stroke='#5A000F' stroke-width='0.255682' />
            </g>
            <defs>
                <filter id='filter0_d_8809_5635' x='0' y='0' width='16' height='17' filterUnits='userSpaceOnUse' color-interpolation-filters='sRGB'>
                    <feFlood flood-opacity='0' result='BackgroundImageFix' />
                    <feColorMatrix in='SourceAlpha' type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0' result='hardAlpha' />
                    <feOffset dy='1' />
                    <feColorMatrix type='matrix' values='0 0 0 0 0.351243 0 0 0 0 0 0 0 0 0 0.0606313 0 0 0 1 0' />
                    <feBlend mode='normal' in2='BackgroundImageFix' result='effect1_dropShadow_8809_5635' />
                    <feBlend mode='normal' in='SourceGraphic' in2='effect1_dropShadow_8809_5635' result='shape' />
                </filter>
                <linearGradient id='paint0_linear_8809_5635' x1='7.97064' y1='1.97656' x2='7.97064' y2='14.0878' gradientUnits='userSpaceOnUse'>
                    <stop stop-color='#F3A9B6' />
                    <stop offset='1' stop-color='white' />
                </linearGradient>
            </defs>
        </svg>

    )
}
